/**
 * Summary
 * This is the global world/chronicle title for Chronos. Clicking the
 * WorldTitle should direct the viewer to an author-defined page (world
 * index, by default) and the ChronicleTitle should either direct the
 * viewer to a defined article, or display the article in the Sidebar.
 */

import React from "react";
import { IconButton } from "../_components";
import { useApp } from "../_contexts";
import ReactTooltip from "react-tooltip";

const defaultOptions = {
  autoOpenSidebar: true,
  enableChronicleSidebar: true,
  sendViewersToWorld: true,
  sendAuthorsToDashboard: true,
  customClass: "",
};

export function ChronicleTitle({ chronicle, world }) {
  // const { chronicle } = props;
  // const { options: chronicleOptions } = chronicle;
  ReactTooltip.rebuild();
  const chronicleOptions = chronicle
    ? chronicle.options
      ? chronicle.options
      : defaultOptions
    : defaultOptions;
  const isDisabled = chronicle && chronicle.setupComplete ? false : true;
  const { openSidebar, editMode } = useApp();
  // const { details: world } = useSelector((state) => state.world);
  const handleChronicleTitleClick = (ev) => {
    if (isDisabled) return;
    if (chronicleOptions && chronicleOptions.enableChronicleSidebar) {
      // console.log('Viewing Chronicle Details', chronicle);
      openSidebar({
        type: "chronicle",
        payload: {},
      });
    }
  };

  const handleDashboardClick = (ev) => {
    if (isDisabled) return;
    ev.preventDefault();
    const { sendAuthorsToDashboard } = chronicleOptions;
    if (editMode && sendAuthorsToDashboard) {
      const link = document.createElement("a");
      link.target = "_blank";
      link.classList.add("chronos-null");
      link.href = `https://www.worldanvil.com/world/${world.waID}/summary`;
      link.click();
      link.remove();
    }
  };

  const handleWorldTitleClick = (ev) => {
    if (isDisabled) return;
    ev.preventDefault();
    const { sendAuthorsToDashboard, sendViewersToWorld } = chronicleOptions;
    if (sendViewersToWorld) {
      // console.log('Opening world in new tab', world);
      const link = document.createElement("a");
      link.target = "_blank";
      link.classList.add("chronos-null");
      console.log("WORLD", world);
      if (sendViewersToWorld) {
        // link.href = `https://www.worldanvil.com/w/${customSlugify(
        //   world.name
        // )}-${customSlugify(world.authors[0].name)}/`;
        link.href = `https://www.worldanvil.com/w/${world.slug}`;
        link.click();
        link.remove();
      }
      // if (sendAuthorsToDashboard) {
      //   link.href = `https://www.worldanvil.com/world/${world.waID}/summary`;
      //   link.click();
      //   link.remove();
      // }
    }
  };
  const worldName = world?.name || "World Anvil";
  // const worldName = 'Lyra' || 'World Anvil';
  const chronicleName = chronicle?.title || "";
  // const chronicleName = 'SUper Long Title TEsT' || '';
  const maxLength = Math.max(worldName.length, chronicleName.length);
  return (
    <div
      className="chronos-chronicle-title"
      style={{ minWidth: `calc(${maxLength} * 0.8rem)` }}
    >
      <div className="chronos-chronicle-title-box">
        <div
          className="chronos-chronicle-name"
          onClick={handleChronicleTitleClick}
        >
          {chronicle?.title || "    "}
        </div>
      </div>
      <div className="chronos-world-title-box"></div>
      <div
        className="chronos-chronicle-world-name"
        onClick={handleWorldTitleClick}
      >
        <span className="chronos-chronicle-world-text">
          {world?.name || "World Anvil"}
        </span>

        {editMode && (
          <span className="chronos-dashboard-btn">
            {world?.name && (
              <IconButton
                iconOnly
                icon="fas fa-globe-stand fa-fw"
                data-tip="Go to World Dashboard (New Tab)"
                data-for="chronosWorldTitleTooltip"
                onClick={handleDashboardClick}
              />
            )}
          </span>
        )}
      </div>
      {/* <div
        className="chronos-chronicle-name"
        onClick={handleChronicleTitleClick}
      >
        {chronicle?.title || '    '}
      </div> */}
      <ReactTooltip id="chronosWorldTitleTooltip" effect="solid" />
      {/* <div
        className="chronos-chronicle-world-name"
        onClick={handleWorldTitleClick}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 695 50"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinejoin: 'round',
            strokeMiterlimit: 2,
          }}
        >
          <g transform="matrix(1,0,0,1,-228.922,-244.375)">
            <path
              d="M253.922,294.375L228.922,244.375L923.922,244.375L898.922,294.375L253.922,294.375Z"
              style={{ fill: 'rgb(115,25,17)' }}
            />
          </g>
        </svg>
        <span className="chronos-world-title">
          <span>{world?.name || 'World Anvil'}</span>
          {editMode && (
            <span className="chronos-dashboard-btn">
              {world?.name && (
                <IconButton
                  iconOnly
                  icon="far fa-th fa-fw"
                  data-tip="Go to World Dashboard (New Tab)"
                  data-for="chronosWorldTitleTooltip"
                  onClick={handleDashboardClick}
                />
              )}
            </span>
          )}
        </span>
      </div>
      <div
        className="chronos-chronicle-name"
        onClick={handleChronicleTitleClick}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 695 50"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinejoin: 'round',
            strokeMiterlimit: 2,
          }}
        >
          <g transform="matrix(1,0,0,1,-228.922,-244.375)">
            <path
              d="M253.922,294.375L228.922,244.375L923.922,244.375L898.922,294.375L253.922,294.375Z"
              style={{ fill: 'rgb(26,26,26)' }}
            />
          </g>
        </svg>
        <span className="chronicle-title">{chronicle?.title || ''}</span>
      </div>
      <ReactTooltip id="chronosWorldTitleTooltip" effect="solid" /> */}
    </div>
  );
}

function customSlugify(str) {
  str = str.replace(" ", "").toLowerCase();
  return str;
}
